import { paginate } from './paginate'

export default {
  name: 'Pagination',
  mixins: [],
  components: {},
  props: {
    items: {
      type: Number,
      required: true
    },
    itemsPerPage: {
      type: Number,
      default: 10,
      required: false
    },
    placeholder: {
      type: String,
      default: '<items>',
      required: false
    },
    inputPlaceholder: {
      type: String,
      default: 'go to',
      required: false
    },
    page: {
      type: Number,
      required: true,
      default: 1
    }
  },
  data () {
    return {
      pager: {},
      input: false
    }
  },
  computed: {
    totalPages () {
      return Math.ceil(this.items / this.itemsPerPage)
    }
  },
  watch: {
    items () {
      this.setupPager()
    },
    page () {
      this.setupPager()
    }
  },
  mounted () {
    this.setupPager(this.page)
  },
  methods: {
    setupPager (page) {
      this.pager = paginate(this.items, page || this.page, this.itemsPerPage)
    },
    setItem (page) {
      this.setupPager(page)
      this.$emit('change', this.pager)
      this.input = false
    },
    setPage (page, emit = true) {
      this.setupPager(page)

      this.input = false
      if (emit) {
        this.$emit('change', this.pager)
      }
    },
    getInputValue () {
      return `${this.pager.startIndex + 1} - ${this.pager.endIndex + 1}`
    },
    showInput () {
      this.input = !this.input
      this.$nextTick(() => {
        this.$refs.inputElement.value = ''
        this.$refs.inputElement.focus()
      })
    }
  }
}
